"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var configuration_1 = require("../../configuration");
/**
 * #config BaseConnection
 */
function x() {} // eslint-disable-line @typescript-eslint/no-unused-vars
exports.default = (0, configuration_1.ConfigurationSchema)('BaseConnection', {
  /**
   * #slot
   */
  name: {
    type: 'string',
    defaultValue: 'nameOfConnection',
    description: 'a unique name for this connection'
  },
  /**
   * #slot
   */
  assemblyNames: {
    type: 'stringArray',
    defaultValue: [],
    description: 'optional list of names of assemblies in this connection'
  }
}, {
  explicitlyTyped: true,
  /**
   * #identifier
   */
  explicitIdentifier: 'connectionId'
});